export default {
  general: {
    section: 'Section',
    loadingTemplate: 'Loading template preview...',
    isExternal: 'for External Insp.',
    externalInspection: 'Enable for external inspections',
    geographic: 'Geographic location',
    latitude: 'Latitude',
    longitude: 'Longitude',
    brand: 'Brand',
    model: 'Model',
    selectWarning: 'Select at least one inspection',
    damage: 'Damage',
    selectStatus: 'Select state',
    finishStatus: 'Success',
    inProgress: 'In progress',
    repairDate: 'Repair date',
    noData: 'No data',
    noGallery: 'No gallery found',
    noRegister: 'No registers found',
    trailer1: 'Towing data 1',
    trailer2: 'Towing data 2',
    downloadReports: 'Download reports',
    fail: 'Fail',
    none: 'None',
    ownerName: 'Unit owner',
    seeDetail: 'See details',
    hideDetail: 'Hide details',
    selectAll: 'Select all',
    changeStatus: 'Change status',
    success: 'Success',
    warn: 'Warn',
    error: 'Error',
    view: 'View',
    description :'Description',
    image: 'Image',
    add: 'Add',
    edit: 'Edit',
    close: 'Close',
    return: 'Return',
    openAll: 'Open all',
    closeAll: 'Close all',
    warning: 'Warning',
    remove: 'Remove',
    home: 'Home',
    subscriptions: 'Subscriptions',
    notifications: 'Notifications',
    unitTypes: 'Unit types',
    unitType: 'Unit Type',
    site: 'Site',
    permissions: 'Permissions',
    history: 'History',
    historyTotal: 'History inspections total',
    manager: 'Manager',
    comment: 'Comment',
    plates: 'Plates',
    plate: 'Plate',
    vin: 'Vin',
    property: 'Property',
    tests: 'Checklists',
    defaultTests: 'Default Checklists',
    sites: 'Sites',
    inspections: 'Inspections',
    inspection: 'Inspection',
    confirm: 'Confirm',
    users: 'Users',
    user: 'User',
    accept: 'Accept',
    cancel: 'Cancel',
    name: 'Name',
    email: 'Email',
    company: 'Company',
    companies: 'Companies',
    lastNames: 'Last names',
    licence: 'Licence',
    role: 'Role',
    plan: 'Plan',
    units: 'Transport units',
    unit: 'Transport unit',
    duration: 'Duration',
    expirationDate: 'Expiration date',
    date: 'Date',
    dateRange: 'Date range',
    login: 'Login',
    logout: 'Logout',
    logoutMessage: 'Are you sure you want to logout?',
    enter: 'Enter',
    change: 'Change',
    phone: 'Phone',
    search: 'Search',
    actions: 'Actions',
    delete: 'Delete',
    save: 'Save',
    reloadFile: 'Reload file',
    loadedElements: 'Loaded elements',
    passwordRule: 'The password must have at least a number, a lowercase and uppercase letter and a special character. ',
    deleteMessage: 'Are you sure that you want to delete this element?',
    register: 'Register',
    pageNotFound: 'Page not found',
    loading: 'Loading',
    goHome: 'Go to home page',
    send: 'Send',
    reports: 'Reports',
    imgFormats: 'Image formats permitted: JPG, JPEG and PNG',
    created: 'Created',
    contacts: 'Contacts',
    subject: 'Subject',
    editUser: 'Edit user information',
    editCompany: 'Edit company information',
    unitNumber: 'Unit number',
    template: 'Template',
    startDate: 'Start date',
    endDate: 'End date',
    unitMonitoring: 'Unit monitoring',
    damageReport: 'Damage report',
    traile: 'Trailer',
    noEco: 'No. Eco',
    noInspection: 'No. Inspection',
    yard: 'Yard',
    damageNotes: 'Damage notes',
    comments: 'Comments',
    owne: 'Owner',
    reportedDamage: 'Reported damage',
    operat: 'Operator',
    customer: 'Customer',
    transitType: 'Transit type',
    loadType: 'Load type',
    origin: 'Origin',
    destination: 'Destination',
    answer: 'Answer',
    damageLevel: 'Damage level',
    typeInspection: 'Type of inspection',
    damages: "Damage",
    incidence: "Incidence",
    ok: "OK",
    yes: "Yes",
    no: "No",
    inspectionDate: "Inspection date",
    checklistName: "Checklist name",
    inspectionYard: "Inspection yard",
    mechanicalCheck: "Physical and mechanical verification",
    smokeCheck: "Smoke check",
    certification: "Certification",
    wetMeasurement: "Wet measurement",
    dryMeasurement: "Dry measurement",
    capacity:  "Capacity",
    typeOperation: "Type of operation",
    status: "Status",
    approved: "Approved",
    refused: "Refused",
    pollution: "Pollution",
    reasonRejection: "Reason for rejection",
    typeTransit:"Type of transit",
    dateLastInspection: "Date of last inspection",
    subscriptionExpirationDate: "Subscription expiration date",
    damageInspections: "Damage in inspections",
    sitesDamage: "Sites with more damage",
    inspectionClassification: "Inspection classification",
    thereIsNoData: "No data available",
    courtYards: "Courtyards",
    resetFilter: "Reset filters",
    errorFilterMessage: "Verify that the filters meet the validations",
    inspector: "Inspector",
    inspectores: "Inspectores",
    operators: "Operators",
    operator: "Operator",
    clients: "Clients",
    administrators: "Administrators",
    admin: "Administrator",
    credential: "Credential",
    credentialNumber: "Credential number",
    photoCredential: "Photo of the credential",
    numberLicense: "License number",
    photoLicense: "Photo of the license",
    vigenteLicense: "License validity",
    photoOperator: "Photo of the operator",
    updatePhotoCredential: "Update credential",
    updatePhotoLicense: "Update license",
    updatePhotoOperator: "Update operator photo",
    dataOfThe: "Data of the",
    registeredUnits: "registered units",
    occurredIncidence : "occurred incidences",
    unitWithDamage: 'units with damage',
    inspectionsToday: 'inspections today',
    accepted: 'accepted',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    month: 'Month',
    assignOperatorInspector: 'Assign operator to inspector',
    assign: 'Assign',
    pass: 'Pass',
    doesNotComply: 'Does not comply',
    reportsCatalog: 'Reports catalog',
    consulting: 'Consulting',
    clickMessage: 'Click on the report you want to consult',
    of: 'of',
    withoutDamage: 'Without damage',
    withoutData: 'Without data',
    quantity: 'Quantity',
    inspectionPointsDamage: 'Inspection points with damage',
    totalDamages: 'Total damages',
    minorDamage: 'Minor damage',
    moderateDamage: 'Moderate damage',
    highDamage: 'High damage',
    damagedOperators: 'Damaged operators',
    intensityDamage: 'Intensity of damage',
    frequencyOfDamagePerUnit: 'Frequency of damage per unit',
    units: 'Units',
    frequency: 'Frequency',
    damagesPerDay: 'Damages per day',
    frequencyOfDamage: 'Frequency of damage(%)'
  },
  dashboard: {
    welcome: 'Welcome',
    changePassword: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New Password',
    confirmPassword: 'confirm Password',
    userInfo: 'User information',
    companyInfo: 'Company information',
    subscription: 'Subscription',
    planMessage: 'Paid subscription for one year',
    passNoMatch: 'Passwords do not match',
    inspectionPerformedReport: 'Inspection report by yard from {starDate} to {endDate}',
    damageInspectionsReport: 'Damage report in inspections from {starDate} to {endDate}',
  },
  login: {
    forgot: 'Forgot password?',
    recover: 'Recover Password',
    change: 'Change password',
    changeMessage: 'You have requested a previous password change. Please, insert the new password with which you will have access to the platform.',
    password: 'Password',
    repeatPassword: 'Repeat password',
    newPassword: 'New Password',
    recoverMessage: 'Enter your email address and we\'ll send you instructions on how to reset your password.',
    dontMatch: 'Passwords don\'t match',
    signUp: 'Sign up',
    noAccount: 'Don\'t have an account?'
  },
  company: {
    add: 'Add company',
    delete: 'Delete company',
    edit: 'Edit company',
    delMessage: 'Are you sure that you want to delete the company ',
    formMessage: 'Enter all the data corresponding to the company information.'
  },
  unitTypes: {
    add: 'Add unit type',
    delete: 'Delete unit type',
    edit: 'Edit unit type',
    delMessage: 'Are you sure that you want to delete the unit type ',
    formMessage: 'Enter all the data corresponding to the unit type information.'
  },
  tests: {
    add: 'Add checklist',
    edit: 'Edit checklist',
    testValidation: 'There must be at least one section and a question per section. Please check again',
    delete: 'Delete checklist',
    delMessage: 'Are you sure that you want to delete the checklist ',
    formMessage: 'Enter all the data corresponding to the checklist.',
    sections: 'Sections',
    questions: 'Questions',
    addSection: 'Add section',
    addQuestion: 'Add question',
    required: 'Comment required',
    noRequired: 'Comment no required',
    photoRequired: 'Photo required',
    photoNoRequired: 'Photo no required',
    critic: 'Critic',
    noCritic: 'No critic',
    delQuestion: 'Delete question',
    delSection: 'Delete section',
    delSectionMessage: 'Are you sure that you want to delete this section?',
    noAnswered: 'There are some sections or questions that have not been completed. Please check again.',
    download: 'Download PDF',
    defaultTestMessage: 'Select the country and the yard that you want to apply the default checklist.',
    templates: {
      security: 'Security',
      platform: 'Platform',
      thermal: 'Thermal',
      trauliner: 'Trauliner'
    },
    defaultCheck: 'Default questionnaire',
    formatPDF: 'PDF Format',
  },
  address: {
    social_reason: 'Business name',
    tax: 'RFC',
    tax_regimen: 'Tax regime',
    name: 'Address',
    street: 'Street',
    suburb: 'Suburb',
    number: 'Number',
    city: 'City',
    state: 'State',
    country: 'Country',
    zip: 'Zip Code',
    additionalInfo: 'Additional info',
    timeZone: 'Time zone'
  },
  subscriptions: {
    add: 'Add subscription',
    edit: 'Edit subscription',
    delete: 'Delete subscription',
    delMessage: 'Are you sure that you want to delete this subscription',
    formMessage: 'Enter all the data corresponding to the subscription.',
  },
  users: {
    add: 'Add user',
    edit: 'Edit user',
    formMessage: 'Enter all the data corresponding to the user information.',
    delMessage: 'Are you sure that you want to delete this users'
  },
  units: {
    add: 'Add transport unit',
    addMultiple: 'Add multiple transport units',
    addPlates: 'Add plates',
    removePlate: 'Remove plate',
    editPlates: 'Edit plate',
    edit: 'Edit transport unit',
    noPlates: 'Not have',
    formMessage: 'Enter all the data corresponding to the transport unit information.',
    multipleFormMessage: 'Download the template and fill it with the corresponding data to load multiple transport units.',
    delMessage: 'Are you sure that you want to delete this transport unit',
    delPlateMessage: 'Are you sure that you want to delete this plate',
    own: 'Own',
    external: 'External',
    OWN: 'Own',
    EXTERNAL: 'External',
    downloadTemplate: 'Download template',
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    IN_GARAGE: "In garage",
  },
  sites: {
    add: 'Add yard',
    edit: 'Edit yard',
    formMessage: 'Enter all the data corresponding to the yard information.',
    addUsers: 'Add users to yard',
    relatedUsers: 'Related users',
    noUsers: 'No users registered',
    delMessage: 'Are you sure that you want to delete this yard',
    delUserMessage: 'Are you sure that you want to delete this user',
    relationUnit: 'List of units',
    preview: 'Preview',
    typeQuestionnaire: {
      title: 'Questionnaire type',
      security: 'Security',
      maintenance: 'Maintenance',
      log: 'Log'
    },
    headers: {
      questionTitle: 'Title of question',
      description: 'Description',
      comment: 'Comments required'
    }
  },
  permissions: {
    assign: 'Assign permissions',
    edit: 'Edit permissions',
    remove: 'Remove permissions',
    rolePermissions: 'Role permissions',
    availablePermissions: 'Available permissions',
    COMPANIES: 'Companies',
    DASHBOARD: 'Dashboard',
    USERS: 'Users',
    SUBSCRIPTIONS: 'Subscriptions',
    NOTIFICATIONS: 'Notifications',
    SITES: 'Sites',
    UNIT_TYPES: 'Unit Types',
    UNITS: 'Transport units',
    QUESTIONNAIRES: 'Checklists',
    HISTORY: 'History',
    INSPECTIONS: 'Inspections',
    REPORTS: 'Reports',
    PERMISSIONS: 'Permissions',
    USER_CREATE: 'Create Users',
    USER_READ: 'List Users',
    USER_UPDATE: 'Update Users',
    USER_DELETE: 'Delete Users',
    COMPANY_CREATE: 'Create Companies',
    COMPANY_READ_ALL: 'List all Companies',
    COMPANY_READ: 'List Companies',
    COMPANY_UPDATE: 'Update Companies',
    COMPANY_DELETE: 'Delete Companies',
    SITE_CREATE: 'Create sites',
    SITE_READ: 'List sites',
    SITE_UPDATE: 'Update sites',
    SITE_DELETE: 'Delete sites',
    SITES_USER_ADD: 'Add Users to sites',
    SITES_USER_READ_ALL: 'List all sites Users',
    SITES_USER_READ: 'List sites Users',
    SITES_USER_REMOVE: 'Remove Users from sites',
    UNIT_TYPE_CREATE: 'Create Unit Types',
    UNIT_TYPE_READ: 'List Unit Types',
    UNIT_TYPE_UPDATE: 'Update Unit Types',
    UNIT_TYPE_DELETE: 'Delete Unit Types',
    UNIT_CREATE: 'Create Transport Units',
    UNIT_READ_ALL: 'List all Transport Units',
    UNIT_READ_ONLY_SITE: 'List Transport units belonging to sites',
    UNIT_UPDATE: 'Update Transport Units',
    UNIT_DELETE: 'Delete Transport Units',
    PLATE_CREATE: 'Create Plates',
    PLATE_READ: 'List Plates',
    PLATE_UPDATE: 'Update Plates',
    PLATE_DELETE: 'Delete Plates',
    QUESTIONNAIRE_CREATE: 'Create Checklists',
    QUESTIONNAIRE_UPDATE: 'Update Checklists',
    QUESTIONNAIRE_READ: 'List Checklists',
    QUESTIONNAIRE_DELETE: 'Delete Checklists',
    QUESTIONNAIRES_DEFAULT_ADD: 'Add Default Checklists',
    INSPECTION_CREATE: 'Create Inspections',
    INSPECTION_FILL: 'Answer Inspections',
    INSPECTION_HISTORY: 'Inspections History',
    INSPECTION_READ: 'List Inspections',
    INSPECTION_REPORT: 'Inspections Reports',
    INSPECTION_DOWNLOAD	: 'Download Inspections',
    CARD_ADD: 'Add Card',
    CHARGE_ADD: 'Add Charge',
    SUBSCRIPTION_EDIT	: 'Edit Subscriptions',
    PERMISSION_EDIT: 'Edit Permissions',
    INSPECTION_DELETE: 'Delete Inspections',
    SUBSCRIPTION_GET_ALL: 'List all Subscriptions',
    SUBSCRIPTION_GET_SHOW: 'Show Subscriptions',
    REPORT_COMPANIES: 'Companies Reports',
    UNITS_MASIVE_UPLOAD: 'Unit massive upload'
  },
  inspections: {
    view: 'View Inspection',
    deleteTitle: 'Delete Inspection',
    delMessage: 'Are you sure that you want to delete this inspection',
    viewImg: 'View image',
    viewImgs: 'View images',
    viewCom: 'View comment',
    tireDetails: 'Tire data',
    tireDetailsReadOnly: 'Information captured from the mobile app. Read only.',
    folio: 'Folio',
    count: 'Inspections Count',
    damageInspections: 'Damage inspections',
    detailTruck: 'Truck data',
    type: 'Tipo',
    charge: 'Loaded',
    transit: 'Transit',
    barrier: 'Barrier seal',
    stamp: 'Stamp',
    freePests: 'Free of pests and/or contaminants',
    seeSeal: 'See seal and lock mechanism',
    sealFiles: 'Verification of seal and documents',
    security: 'Pull security seal',
    flipSeal: 'Twist and flip security seal',
    input: "Input",
    output: "Output",
    on_route: "On route",
    yes: "Yes",
    no: "No",
    export: "Export",
    import: "Import",
    empty: "Empty",
    emptyPremises: "Empty premises",
    loaded: "Local loaded",
    throwing: "Throwing",
    outsider: "Outsider",
    slight: "Slight",
    moderate: "Moderate",
    high: "High",
    none: "None",
    totalInspections: "Total inspections",
    inspectedPoints: "Inspected points",
    unitsWithHighDamage: 'Units with high damage'
  },
  validation: {
    tax: 'Please enter a valid RFC with homoclave',
    required: 'Required field.',
    startDate: 'Start date is required',
    endDate: 'End date is required',
    minNumberChars: 'Must be at least {number} characters.',
    minNumber: 'Must be at least {number} numbers.',
    maxNumberChars: 'May not be greater than {number} characters.',
    maxNumber: 'May not be greater than {number} numbers.',
    exactNumberChars: 'Must be {number} characters.',
    exactNumber: 'Must be {number} numbers.',
    minNumberDigits: 'Must be at least {number}.',
    maxNumberDigits: 'May not be greater than {number}.',
    exactNumberDigits: 'Must be {number}.',
    invalidEmail: 'Must be a valid email address.',
    invalidDecimal: 'Must be a number.',
    noSpecialChars: 'The item must not have any special character',
    exchange: '2 digits and up to 6 decimal places allowed',
    specificDecimal: '15 digits and up to 3 decimal places allowed',
    fiveDigits: 'Exactly 5 digits',
    invalidNumber: 'Invalid number',
    onlyLetters: 'The item must have only letters',
    noSpace: 'The item must be only one word',
    deleteUserQuestion: 'Are you sure you want to delete the user <b>{name}</b> with email <b>{email}</b>?',
    deleteSubscriptionQuestion: 'Are you sure you want to delete the subscription of <b>{company}</b>?',
    passwordsDoNotMatch: 'Passwords do not match',
    success: 'Success',
    error: 'Error',
    nonAllowedCharacters: 'Non allowed characters',
    coordinate: 'Must contain only positive and negative numbers',
    invalidMonth: 'Invalid month',
    plate: 'Enter a minimum of {minimo} and a maximum of {maximo} characters for license plates and special characters are not accepted',
    addData: 'Please add the requested data in the form',
    errorData: 'Error in data, please verify the entered information'
  },
  dropzone: {
    default: 'Drag and drop files here to upload.<br> Max {size}{unit}',
    fallback: 'The browser is incompatible, the simple file upload will be used',
    fileTooBig: 'File too big, the file size is {{filesize}} and the limit is {{maxFilesize}}',
    invalidFileType: 'Invalid file type',
    responseError: 'An error ocurred processing the file upload, code: {{statusCode}}',
    cancelUpload: 'Cancel upload',
    uploadCanceled: 'Upload cancelled',
    cancelUploadConfirmation: 'Do you want to cancel the file upload?',
    removeFile: 'Remove file',
    removeFileConfirmation: 'Do you want to remove the file',
    maxFilesExceeded: 'Limit of number of files exceeded',
    uploadMessage: 'Drag and drop or click here to upload a logo.<br>  Max {size}{unit}',
    logoSuccess: 'Logo uploaded succesfully',
    fileSuccess: 'File uploaded succesfully',
    fileFormat: 'File formats permitted: {formats}',
    credentialOperator: 'Drag and drop the operator credential image here in JPG or PNG format.<br> Max {size}{unit}',
    licenseOperator: 'Drag and drop the operator license image here in JPG or PNG format.<br> Max {size}{unit}',
    photoOperator: 'Drag and drop the operator photo here in JPG or PNG format.<br> Max {size}{unit}',
    addPhotoRequired: 'Please add the requested photos/images in the form'
  },
  wizard: {
    selectSubscription: 'Select your Subscription',
    cardInfo: 'Card information',
    next: 'Next',
    back: 'Back',
    finish: 'Finish',
    registration: 'Registration',
    owner: 'Cardholder name',
    card: 'Card number',
    year: 'Expiration year',
    month: 'Expiration month',
    code: 'Security code',
    subscription: 'Subscription',
    cardTitle: 'Tarjeta',
    wireTransfer: 'Transferencia bancaria',
    paymentMethod: 'Payment method',
    processInfo: 'Procesing information',
    wait: 'Wait, please',
    licence_number: 'Licence number',
    accountSuccess: 'Account created successfully',
    accountSuccessMsg: 'You will shortly receive an email confirming the creation of your account.',
    thanks: 'Thanks for joining Intercambios',
    downloadOrder: 'Download purchase order',
    bankMessage: 'Download your purchase order and pay for your subscription in some of the authorized institutions.',
    msg1: 'By hiring the application you get 1 year of membership, without limits or restrictions, you can have:',
    msg2: 'After the annuity, we will contact you to continue enjoying the benefits of the application',
    Limitado: 'Limited',
    Ilimitado: 'Unlimited',
    annual: 'Annual',
    usersLimit: 'Users limit',
    inspectionsLimit: 'Inspections limit'
  },
  notification: {
    title: 'Title',
    message: 'Message',
    level: 'Importance level',
    importance: 'Importance',
    HIGH: 'High',
    LOW: 'Low',
    view: 'View',
    yes: 'Yes',
    no: 'No',
    markView: 'Mark as view',
    deleteSelect: 'Delete selected',
    markSelect: 'Mark selected as view',
    delete: 'Delete notification',
    delMessage: 'Are you sure you want to delete this notification?',
    delMassive: 'Are you sure you want to delete the selected notifications?',
    markMassive: 'Are you sure you want to mark as view the selected notifications?'
  },
  reports: {
    filterMessage: 'Filter the search',
    inspectionUnitTypes: 'Inspections and unit types report',
    inspectionReportInspector: 'Inspections by inspector',
    inspectionReportInspectorMessage: 'Analyze the inspections performed by the inspector',
    incidentsInspector: 'Incidents per inspector',
    incidentsInspectorMessage: 'Analyze incidents detected by inspector',
    incidentsUnitType: 'Incidents by units',
    incidentsUnitTypes: 'Incidents_by_units',
    incidentUnitType: 'Incidents by unit',
    incidentUnitTypeMessage: 'Indicates units with more incidents',
    checklistReport: 'Checklist report',
    checklistReportMessage: 'Consult results of performed checklists',
    downloadReport: 'Download Report',
    filter: 'Filter',
    filterWarning: 'It is necessary to select at least one filter to perform the search',
    InspectionsByUnitType: 'Report_inspections_by_unit_type',
    InspectionsByInspector: 'Report_inspections_by_inspector',
    IncidentsByInspector: 'Report_incidents_by_inspector',
    IncidentsByUnit: 'Report_incidents_by_unit',
    ChecklistReport: 'Report_checklist',
    inspectionsByUnitType: 'Inspections by unit type',
    inspectionsByUnitTypeMessage: 'See inspections grouped by unit type',
    incidentsAndDamages: 'Incidents and damages',
    checklist: 'Checklist',
    inspectionPointsWithDamages: 'Inspection points with damages',
    inspectionPointsWithDamagesDoc: 'Inspection_points_with_damages',
    inspectionPointsWithDamagesMessage: 'Identify the inspection points where more damages have been reported',
    operatorsWithDamage: 'Operators with damages',
    operatorsWithDamages: 'Operators_with_damages',
    operatorsWithDamageMessage: 'Shows the operators linked to inspections where damage has been reported',
    frequencyOfDamagesByUnit: 'Frequency of damages by unit',
    frequencyOfDamagesByUnitMessage: 'Analyzes the frequency with which damages are reported with each unit',
    inspectionDetails: 'Inspection details',
    inspectionCountByUnit: 'Inspection count',
    inspectionCountByUnitMessage: 'Check the number of inspections performed per unit',
    unitInspections: 'Unit inspections',
    inspectionCountByUnitDoc: 'Report_Inspection_count_by_unit',
    tireChangeReport: 'Tire change report',
    tireChangeReportMessage: 'Check the tire changes detected between inspections',
    tireChangeReportDoc: 'Report_Tire_change',
    totalInspections: 'Total inspections',
    totalChanges: 'Total changes',
    lastResult: 'Last result',
    changesCount: '{count} change | {count} changes',
    noChanges: 'No changes',
    yard: 'Yard',
    previousInspectionDate: 'Previous inspection date',
    changes: 'Changes',
    noPreviousInspection: 'No previous inspection',
    incompleteInspection: 'Incomplete inspection',
    missingFieldsCount: 'Incomplete inspection: {count} missing field | Incomplete inspection: {count} missing fields',
    changesFound: 'Changes found',
    inspectionPoint: 'Inspection point',
    evaluatedField: 'Evaluated field',
    previousValue: 'Previous value',
    currentValue: 'Current value',
    showChanges: 'Show changes'
  },
  monitoring: {
    plaque: 'Plaques',
    numberEconomic: 'Economic number',
    unit_type: 'Unit type',
    yard: 'Site',
    property: 'Property',
    levelDamage: 'Damage level',
    inactiveDays: 'Inactive days',
    trasnport_unit: 'Unit transport',
    downloadPhotos: 'Download photos',
    graphic: 'Graphic',
    seeDetailsReport: 'See damage report',
    damageGallery: 'Damage gallery',
    question: 'Question',
    low: 'Low',
    warning: 'Warning',
    high: 'High',
    year: 'Year',
    selectAll: 'Select all photos',
    lastInspection: 'Last inspection',
    reportedDamage: 'Reported damage',
    graphicTitle: 'Evolution of incidents',
    photographicEvidence: 'Photographic evidence'
  },
  incidents: {
    event: 'Event log',
    detail: 'Detail of incidents'
  },
  unit: {
    title: 'Unit',
    rejected: 'Rejected units',
  }
}